module.exports = __webpack_public_path__ + "img/st-engineering-thumb.e0e0c9c4.png";